import React from "react";
import { Heart, Instagram, Facebook, Mail, Phone } from "lucide-react";
import { Separator } from "./ui/separator";
import { footerLinks, contactInfo } from "../data/mock";

export const Footer = () => {
  const handleNavClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      className="border-t border-white/5 pt-16 pb-8 px-6"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex flex-col leading-none mb-4">
              <span className="font-display text-[1.6rem] font-bold tracking-[0.04em] text-white">
                LOBBEN
              </span>
              <span className="text-[0.65rem] font-medium tracking-[0.32em] uppercase mt-[1px]" style={{ color: "#C8A97E" }}>
                Event Co.
              </span>
            </div>
            <p className="text-white/40 leading-relaxed max-w-md mb-6">
              Premium wedding and event DJ services. We create unforgettable
              experiences through expertly curated music, polished execution, and
              genuine passion for celebration.
            </p>
            <p className="text-white/25 text-xs tracking-wide mb-6">
              Denver Wedding DJ | Colorado Event DJ
            </p>
            {/* Contact details */}
            <div className="space-y-2 mb-6">
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 text-white/40 hover:text-gold text-sm">
                <Mail className="h-3.5 w-3.5" />
                {contactInfo.email}
              </a>
              <a href="tel:+17204326407" className="flex items-center gap-2 text-white/40 hover:text-gold text-sm">
                <Phone className="h-3.5 w-3.5" />
                {contactInfo.phone}
              </a>
            </div>
            {/* Social */}
            <div className="flex gap-4">
              <a
                href={contactInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-gold hover:border-gold/30"
                style={{
                  backgroundColor: "rgba(255,255,255,0.03)",
                  transition: "color 0.3s ease, border-color 0.3s ease",
                }}
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={contactInfo.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/40 hover:text-gold hover:border-gold/30"
                style={{
                  backgroundColor: "rgba(255,255,255,0.03)",
                  transition: "color 0.3s ease, border-color 0.3s ease",
                }}
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/40 hover:text-gold text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/40 hover:text-gold text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-sm">
            &copy; {new Date().getFullYear()} Lobben Event Co. All rights
            reserved.
          </p>
          <p className="text-white/20 text-xs flex items-center gap-1">
            Crafted with{" "}
            <Heart className="h-3 w-3 text-gold" /> for unforgettable
            celebrations
          </p>
        </div>
      </div>
    </footer>
  );
};
